import { useCallback, useRef } from 'react';
import { useModalHandlers } from 'components/modal';
import { useSystemState } from 'redux/hooks/common';
import { SystemState } from 'redux/reducers/commonReducer';

const useSystemBusyCheck = () => {
  const { showModal, hideModal } = useModalHandlers();
  const systemState = useSystemState();
  const isSystemBusyRef = useRef<boolean>(false);
  const isSystemBusy = systemState !== SystemState.IDLE;
  isSystemBusyRef.current = isSystemBusy;

  const checkSystemBusy = useCallback(
    (callback: () => void) => {
      if (isSystemBusyRef.current) {
        showModal({
          heading: 'Task in Progress',
          body: 'Rock Maker is currently busy performing a task. Please try again later.',
          isOkOnly: true,
          okButtonText: 'OK',
          onOk: hideModal,
        });
        return;
      }
      callback();
    },
    [showModal, hideModal],
  );

  return { checkSystemBusy };
};

export default useSystemBusyCheck;
